window.Page = {

    // Let's launch this thing
    liftoff : () => {
        Page.interactiveSvgMap()
    },

    interactiveSvgMap : () => {

        document.querySelectorAll('.map-icon').forEach(mapIcon => {

            mapIcon.addEventListener('click' , () => {

                // Grab the index
                let index = mapIcon.dataset.index;
                
                document.querySelector(`.sidebar-nav-link:nth-child(${index}`).click()

            })


        })


    }

};

Page.liftoff()